module.exports = __webpack_public_path__ + "img/deliver2.d68519f7.webp";